const curiousFacts = [
      {
        title: "Criada em 1959",
        text: "A Barbie foi criada por Ruth Handler e lançada pela empresa de brinquedos Mattel em 9 de março de 1959. Ela foi inspirada por uma boneca alemã chamada Bild Lilli."
      },
      {
        title: "Nome completo",
        text: "O nome completo da Barbie é Barbara Millicent Roberts. Ela recebeu o nome de Barbara (Barbie) por causa da filha dos criadores e seu sobrenome é Roberts."
      },
      {
        title: "Primeira boneca adulta",
        text: "Antes da Barbie, as bonecas eram, em sua maioria, bebês ou crianças pequenas. Ela foi a primeira boneca adulta feita para representar uma jovem mulher."
      },
      {
        title: "Mais de 200 carreiras",
        text: "A Mattel estima que a Barbie já teve mais de 200 carreiras diferentes, abrangendo uma ampla variedade de profissões e interesses, desde astronauta até médica, piloto, engenheira e muito mais."
      },
      {
        title: "Nacionalidades diversas",
        text: "A Barbie já foi lançada com mais de 50 nacionalidades diferentes, refletindo sua abordagem para promover a diversidade e inclusão."
      },
      {
        title: "Escala humana",
        text: "Se a Barbie fosse uma pessoa em tamanho real, ela teria cerca de 1,75 metros de altura e aproximadamente 91 centímetros de busto, 46 centímetros de cintura e 84 centímetros de quadril."
      },
      {
        title: "Parcerias com celebridades",
        text: "A Barbie já teve várias edições especiais em parceria com celebridades e marcas famosas, incluindo personagens da Disney, estrelas do cinema, estilistas famosos e até mesmo algumas edições inspiradas em supermodelos como Cindy Crawford."
      },
      {
        title: "Mudança na linha de produtos",
        text: "A Barbie evoluiu ao longo dos anos para se tornar mais inclusiva. Em 2016, a Mattel lançou bonecas com diferentes tipos de corpo, tons de pele, cores de cabelo e olhos, bem como variações de altura."
      },
      {
        title: "Casa dos sonhos",
        text: "A 'Barbie Dreamhouse' (Casa dos Sonhos da Barbie) é um dos brinquedos mais populares da história da Barbie. Ela passou por várias atualizações ao longo dos anos para acompanhar as tendências e inovações tecnológicas."
      },
      {
        title: "Presença no espaço",
        text: "Em 1965, a astronauta Barbie foi lançada, tornando-se a primeira boneca a viajar para o espaço sideral, fazendo parte da missão 'Apollo 11' em 1969."
      },    
];
export default curiousFacts;

